import React from 'react'
import Layout from '../modules/Layout'
import InspirationHeaderBlock from '../blocks/InspirationHeaderBlock'
import BodyBlocks from '../technical/BodyBlocks'
import ScrollHintModule from '../modules/ScrollHintModule'
import SEO from '../modules/Seo'

const InspirationPage = ({ locale, content, name, alternates }) => {
  return (
    <div>
      <Layout locale={locale} alternates={alternates}>
        <SEO content={content} name={name} og_locale={locale} />
        <InspirationHeaderBlock block={{ headline: content.headline }} />
        <BodyBlocks body={content.body} />
        <ScrollHintModule />
      </Layout>
    </div>
  )
}

export default InspirationPage
